module.exports = __webpack_public_path__ + "img/controls.b59c7a11.svg";